import { DashboardProcessingResultsComponent } from './components/dashboard-processing-results/dashboard-processing-results.component';
import { DashboardResidualsOutlookComponent } from './components/dashboard-residuals-outlook/dashboard-residuals-outlook.component';
import { DashboardActiveResidualsComponent } from './components/dashboard-active-residuals/dashboard-active-residuals.component';
import { NgModule } from '@angular/core';
import { DashboardComponent } from './dashboard.component';
import { TimelineComponent, NotificationComponent, ChatComponent, DashListComponent, ArticleListComponent, DashboardCellComponent, DashboardCellBodyComponent, DashboardKpiComponent } from './components';
import { DashboardVolComponent } from './components/dashboard-vol/dashboard-vol.component';
import { DashboardAppsComponent } from './components/dashboard-apps/dashboard-apps.component';
import { GrowthChartComponent } from '../charts/components/growth-chart/growth-chart.component';
import { BoardedMerchantCountsChartComponent } from '../charts/components/boarded-merchant-counts-chart/boarded-merchant-counts-chart.component';
import { EvoRoundedCurrencyPipeNoDecimals, EvoRoundedCurrencyPipeNoDecimalsThousands, EvoRoundedPipeNoDecimalsThousands } from 'app/shared/pipes/evoRoundedCurrencyPipe';
import { DashboardGrowComponent } from './components/dashboard-growth/dashboard-grow.component';
import { DashboardClosedComponent } from './components/dashboard-closed/dashboard-closed.component';
import { DashboardPendAppComponent } from './components/dashboard-pend-app/dashboard-pend-app.component';
import { SecurableModule } from 'app/shared/securables/Securable.module';
import { CommonModule } from '@angular/common';
import { StatModule } from 'app/shared';
import { SpinnerOverlayModule } from 'app/shared/components/spinner-overlay/spinner-overlay.module';
import { BindingContextAlertComponentModule } from 'app/shared/components/binding-context-alert-component/binding-context-alert-component.module';
import { ChartsModule as Ng2Charts } from 'ng2-charts';
import { DashboardBoardedComponent } from './components/dashboard-boarded/dashboard-boarded.component';
import { DragulaModule } from 'ng2-dragula';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DashboardTopPerfComponent } from './components/dashboard-top-perf/dashboard-top-perf.component';
import { ResidualOutlookChartComponent } from './components/dashboard-residuals-outlook/residual-outlook-chart/residual-outlook-chart.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
	imports: [
		CommonModule,
		StatModule,
		Ng2Charts,
		SpinnerOverlayModule,
		SecurableModule,
		BindingContextAlertComponentModule,
		DragulaModule,
		NgbModule,
		FontAwesomeModule
	],
	declarations: [
		DashboardComponent,
		TimelineComponent,
		NotificationComponent,
		ChatComponent,
		DashListComponent,
		ArticleListComponent,
		DashboardCellComponent,
		DashboardCellBodyComponent,
		DashboardKpiComponent,
		DashboardVolComponent,
		DashboardAppsComponent,
		GrowthChartComponent,
		BoardedMerchantCountsChartComponent,
		EvoRoundedCurrencyPipeNoDecimals,
		EvoRoundedCurrencyPipeNoDecimalsThousands,
		EvoRoundedPipeNoDecimalsThousands,
		DashboardGrowComponent,
		DashboardClosedComponent,
		DashboardPendAppComponent,
		DashboardBoardedComponent,
		DashboardTopPerfComponent,
		DashboardActiveResidualsComponent,
		DashboardResidualsOutlookComponent,
		ResidualOutlookChartComponent,
		DashboardProcessingResultsComponent
	],
	exports: [
		DashboardComponent,
		TimelineComponent,
		NotificationComponent,
		ChatComponent,
		DashListComponent,
		ArticleListComponent,
		DashboardCellComponent,
		DashboardCellBodyComponent,
		DashboardKpiComponent,
		DashboardVolComponent,
		DashboardAppsComponent,
		GrowthChartComponent,
		BoardedMerchantCountsChartComponent,
		EvoRoundedCurrencyPipeNoDecimals,
		EvoRoundedCurrencyPipeNoDecimalsThousands,
		EvoRoundedPipeNoDecimalsThousands,
		DashboardGrowComponent,
		DashboardClosedComponent,
		DashboardPendAppComponent,
		DashboardBoardedComponent,
		DashboardTopPerfComponent,
		DashboardActiveResidualsComponent,
		DashboardResidualsOutlookComponent,
		ResidualOutlookChartComponent,
		DashboardProcessingResultsComponent
	],
	providers: [

	]
})
export class DashboardSubModule {}
